import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  campaignsService,
  Campaign,
  RecordDecisionRequest,
  UpdateWinnerRequest,
} from '@aslanpay/portal-common-lib';

interface RecordDecisionMutation {
  campaignId: string;
  request: RecordDecisionRequest;
}

interface UpdateWinnerMutation {
  campaignId: string;
  request: UpdateWinnerRequest;
}

const useRecordDecision = (
  options: UseMutationOptions<Campaign, Error, RecordDecisionMutation>
) => {
  return useMutation<Campaign, Error, RecordDecisionMutation>(
    ({ campaignId, request }) => campaignsService.recordCampaignDecision(campaignId, request),
    options
  );
};

const useUpdateWinner = (options: UseMutationOptions<Campaign, Error, UpdateWinnerMutation>) => {
  return useMutation<Campaign, Error, UpdateWinnerMutation>(
    ({ campaignId, request }) => campaignsService.updateCampaignWinner(campaignId, request),
    options
  );
};

export default { useRecordDecision, useUpdateWinner };
